// Every order for the sample contact, newest first, used by Recent Purchases, the Orders tab and Ordering Cadence

export type OrderChannel = 'Club' | 'Early renewal · Portal' | 'Early renewal · Admin' | 'Online' | 'One-time · WinePik';
export type OrderChannelGroup = 'club' | 'one-time';

export interface ContactOrderItem {
  title: string;
  vintage: string;
  quantity: number;
  price: number; // per bottle
}

export interface ContactOrderRecord {
  orderNumber: string;
  date: string; // YYYY-MM-DD
  channel: OrderChannel;
  items: ContactOrderItem[];
}

// Club orders are scheduled renewals and early renewals; one-time orders are everything else
export const orderChannels: {
  channel: OrderChannel;
  group: OrderChannelGroup;
  description: string;
}[] = [{
  channel: 'Club',
  group: 'club',
  description: 'Scheduled subscription renewal'
}, {
  channel: 'Early renewal · Portal',
  group: 'club',
  description: 'Customer renewed early from the customer portal'
}, {
  channel: 'Early renewal · Admin',
  group: 'club',
  description: 'Staff renewed early from the WinePik admin'
}, {
  channel: 'Online',
  group: 'one-time',
  description: 'Bought through the Shopify store checkout'
}, {
  channel: 'One-time · WinePik',
  group: 'one-time',
  description: 'Staff created a one-time order in WinePik'
}];

const shiraz = (quantity: number): ContactOrderItem => ({
  title: 'Barossa Shiraz',
  vintage: '2021',
  quantity,
  price: 45
});
const riesling = (quantity: number): ContactOrderItem => ({
  title: 'Eden Valley Riesling',
  vintage: '2023',
  quantity,
  price: 36
});
const grenache = (quantity: number): ContactOrderItem => ({
  title: 'McLaren Vale Grenache',
  vintage: '2022',
  quantity,
  price: 42
});
const cabernet = (quantity: number): ContactOrderItem => ({
  title: 'Coonawarra Cabernet Sauvignon',
  vintage: '2020',
  quantity,
  price: 55
});
const chardonnay = (quantity: number): ContactOrderItem => ({
  title: 'Adelaide Hills Chardonnay',
  vintage: '2023',
  quantity,
  price: 38
});

// Premium Club (6 bottles every 2 months) and Reds Club (12 bottles quarterly) packs
const premiumA = () => [shiraz(3), riesling(2), grenache(1)];
const premiumB = () => [cabernet(2), shiraz(2), riesling(2)];
const reds = () => [shiraz(4), grenache(4), cabernet(4)];

export const contactOrders: ContactOrderRecord[] = [{
  orderNumber: '#4560',
  date: '2026-10-05',
  channel: 'Club',
  items: premiumA()
}, {
  orderNumber: '#4498',
  date: '2026-08-05',
  channel: 'Club',
  items: premiumB()
}, {
  orderNumber: '#4471',
  date: '2026-07-14',
  channel: 'Early renewal · Admin',
  items: reds()
}, {
  orderNumber: '#4433',
  date: '2026-06-05',
  channel: 'Club',
  items: premiumA()
}, {
  orderNumber: '#4410',
  date: '2026-05-16',
  channel: 'One-time · WinePik',
  items: [grenache(6)]
}, {
  orderNumber: '#4388',
  date: '2026-04-20',
  channel: 'Club',
  items: reds()
}, {
  orderNumber: '#4352',
  date: '2026-03-28',
  channel: 'Early renewal · Portal',
  items: premiumB()
}, {
  orderNumber: '#4316',
  date: '2026-02-14',
  channel: 'Online',
  items: [chardonnay(3), shiraz(3)]
}, {
  orderNumber: '#4301',
  date: '2026-02-05',
  channel: 'Club',
  items: premiumA()
}, {
  orderNumber: '#4270',
  date: '2026-01-20',
  channel: 'Club',
  items: reds()
}, {
  orderNumber: '#4215',
  date: '2025-11-29',
  channel: 'Early renewal · Portal',
  items: premiumB()
}, {
  orderNumber: '#4190',
  date: '2025-11-15',
  channel: 'One-time · WinePik',
  items: [cabernet(3), shiraz(3)]
}, {
  orderNumber: '#4161',
  date: '2025-10-20',
  channel: 'Club',
  items: reds()
}, {
  orderNumber: '#4132',
  date: '2025-10-05',
  channel: 'Club',
  items: premiumA()
}, {
  orderNumber: '#4074',
  date: '2025-08-16',
  channel: 'Online',
  items: [shiraz(2), grenache(1)]
}, {
  orderNumber: '#4058',
  date: '2025-08-05',
  channel: 'Club',
  items: premiumB()
}, {
  orderNumber: '#4031',
  date: '2025-07-20',
  channel: 'Club',
  items: reds()
}, {
  orderNumber: '#3996',
  date: '2025-06-05',
  channel: 'Club',
  items: premiumA()
}, {
  orderNumber: '#3970',
  date: '2025-05-17',
  channel: 'Online',
  items: [chardonnay(3), shiraz(3)]
}];
